<template>
  <el-upload class="uploader" name="image" :action="action" :headers="headers" :show-file-list="false"
    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
    <slot>
      <el-button>{{ $t('public64') }}</el-button>
    </slot>
  </el-upload>
</template>

<script>
import cookie from '@utils/cookie'
export default {
  props: {
    file_directory: {
      default: 'file'
    }
  },
  data () {
    const token = cookie.get('kg-client-token')
    return {
      headers: {
        token: token || ''
      },
      action: '/api/user/uploadImage',
      imageUrl: ''
    }
  },
  methods: {
    handleAvatarSuccess (res, file) {
      console.log('res', res)
      this.$emit('fileChange', res.data.path)
      // console.log('res', res.data.data)
      // console.log('file', file)
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$alert(this.$t('public63'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'warning-alert',
          callback: action => {
          }
        })
      }
      return isLt2M
    }
  }
}
</script>

<style scope lang="scss">
.uploader-icon {
  font-size: 20px;
  color: #8c939d;
  width: 20px;
  height: 100px;
  line-height: 20px;
  text-align: center;
}
</style>
